"use client"

import * as React from "react"
import { Check, X, AlertTriangle } from "lucide-react"
import { cn } from "@/lib/utils"
import { useCompareStore } from "@/hooks/use-compare"

export function CompareToast() {
  const toasts = useCompareStore((s) => s.toasts)
  const dismiss = useCompareStore((s) => s.dismissToast)

  if (toasts.length === 0) return null

  return (
    <div className="pointer-events-none fixed top-6 right-6 z-50 flex flex-col gap-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={cn(
            "pointer-events-auto flex items-center gap-3 rounded-lg border bg-white px-4 py-3 shadow-lg dark:bg-slate-900",
            toast.variant === "warning"
              ? "border-amber-300 dark:border-amber-700"
              : "border-slate-200 dark:border-slate-700"
          )}
        >
          {toast.variant === "warning" ? (
            <AlertTriangle className="h-4 w-4 shrink-0 text-amber-500" />
          ) : (
            <Check className="h-4 w-4 shrink-0 text-nova-600" />
          )}
          <p className="text-sm font-medium text-slate-800 dark:text-slate-100">
            {toast.message}
          </p>
          <button
            onClick={() => dismiss(toast.id)}
            className="ml-1 text-slate-400 hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      ))}
    </div>
  )
}
